module.exports = __webpack_public_path__ + "static/media/6-audio.34ad01c.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/6-audio.wav
// module id = KWiG
// module chunks = 0